import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, Info } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Field } from "@/pages/RegisterCustomer";

export default function RegisterSeller() {
  const nav = useNavigate();
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [f, setF] = useState({
    yard_name: "", cr_number: "", owner_name: "", mobile: "", email: "",
    password: "", city: "جدة", address: "", contact: "", working_hours: "",
  });
  const up = (k) => (e) => setF({ ...f, [k]: e.target.value });

  useEffect(() => { api.get("/cities").then(({ data }) => setCities(data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register/seller", f);
      toast.success("أرسلنا رمز تفعيل إلى بريدك الإلكتروني");
      nav("/verify-email", { state: { email: data.email, role: data.role } });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-14">
      <h1 className="font-head text-2xl sm:text-3xl font-black text-white text-center mb-2">سجّل تشليحك مجانًا</h1>
      <p className="text-sm text-[var(--text-muted)] text-center mb-6">بدون أي عمولة على مبيعاتك — قيمة القطعة كاملة تعود لك</p>

      <div className="ts-card p-4 mb-6 flex gap-3 items-start bg-[var(--amber)]/5">
        <Info size={18} className="text-[var(--amber)] shrink-0 mt-0.5" />
        <p className="text-xs text-[var(--text-muted)] leading-relaxed">رقم السجل التجاري إلزامي. سيتم مراجعة بياناتك من قبل الإدارة، وبعد الموافقة تحصل على علامة «تشليح موثق» ويمكنك إضافة القطع وإدارة متجرك.</p>
      </div>

      <form onSubmit={submit} className="ts-card p-6 grid sm:grid-cols-2 gap-4">
        <Field label="اسم التشليح / المنشأة" testid="seller-yard-name" value={f.yard_name} onChange={up("yard_name")} required />
        <Field label="رقم السجل التجاري" testid="seller-cr" value={f.cr_number} onChange={up("cr_number")} required />
        <Field label="اسم صاحب المنشأة" testid="seller-owner" value={f.owner_name} onChange={up("owner_name")} required />
        <Field label="رقم الجوال" testid="seller-mobile" value={f.mobile} onChange={up("mobile")} placeholder="05xxxxxxxx" required />
        <Field label="البريد الإلكتروني" testid="seller-email" type="email" value={f.email} onChange={up("email")} required />
        <Field label="كلمة المرور" testid="seller-password" type="password" value={f.password} onChange={up("password")} required />
        <div>
          <label className="text-xs font-bold text-[var(--text-muted)] block mb-1.5">المدينة</label>
          <select data-testid="seller-city" value={f.city} onChange={up("city")} className="w-full rounded-xl bg-[var(--bg-secondary)] px-4 py-3 text-white outline-none">
            {cities.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
          </select>
        </div>
        <Field label="أوقات العمل" testid="seller-hours" value={f.working_hours} onChange={up("working_hours")} placeholder="9 صباحًا - 11 مساءً" />
        <div className="sm:col-span-2">
          <Field label="عنوان التشليح" testid="seller-address" value={f.address} onChange={up("address")} required />
        </div>
        <div className="sm:col-span-2">
          <button data-testid="seller-register-submit" disabled={loading} className="btn-amber w-full justify-center disabled:opacity-60">
            <ShieldCheck size={18} /> {loading ? "جارٍ الإرسال..." : "إرسال طلب التسجيل"}
          </button>
        </div>
      </form>
      <p className="text-center text-sm text-[var(--text-muted)] mt-6">لديك حساب تشليح؟ <Link to="/login" className="text-[var(--amber)] font-bold">سجّل الدخول</Link></p>
    </div>
  );
}
